import { createSignal } from 'solid-js';

/**
 * One loan filling the page, or null for the grid of them.
 *
 * Its own store rather than a field on the accounts view: a loan is not an
 * account, and the two pages are never on screen together, so sharing a signal
 * would only mean one could strand the other in a state its own page cannot
 * see or clear.
 */
const [focusedLoanId, setFocusedLoanId] = createSignal<string | null>(null);

export { focusedLoanId };

export const focusLoan = (loanId: string): void => {
    setFocusedLoanId(loanId);
};

export const unfocusLoan = (): void => {
    setFocusedLoanId(null);
};
